import React, { useState, useRef, useEffect } from 'react';


function CopyIcon({text, color='grey', title='Kopiera text'}) {
    const [copyBgColor, setCopyBgColor] = useState('');
    const timerId = useRef(null);

    useEffect(() => {
        if (copyBgColor) {
            timerId.current = setTimeout(() => {
                setCopyBgColor('');
            }, 500);
        }

        return () => {
            clearTimeout(timerId.current);
        };
    }, [copyBgColor]);

    return (
        <i className="fa fa-copy action-icon" title={title} style={{backgroundColor: copyBgColor}}
           onClick={(event) => {
               setCopyBgColor(color)
               if (navigator.clipboard)
                   navigator.clipboard.writeText(text)
           }}></i>
    )
}

export default CopyIcon;